import { FormViewModalProps, LibraryDocumentModalProps } from './FormViewModal';
import { openModal } from '@core/components/ModalStack';

export async function opemFormViewModal(props: FormViewModalProps) {
  const { FormViewModal } = await import('./FormViewModal');

  openModal(FormViewModal, props);
}

export async function openLibraryDocumentModal(props: LibraryDocumentModalProps) {
  const { LibraryDocumentModal } = await import('./FormViewModal');

  openModal(LibraryDocumentModal, props, { id: 'library', name: 'library' });
}
